import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
const ProgressSteps = ({ activeStep, steps }) => {
  const { t } = useTranslation();
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <Stepper activeStep={activeStep} sx={{marginBottom:"2rem"}} alternativeLabel>
      {steps.map((label, index) => (
        <Step key={index}>

          {matches? <StepLabel>{t(label)}</StepLabel> : <StepLabel></StepLabel>}
        </Step>
      ))}
    </Stepper>
  );
};

export default ProgressSteps;